import { createFileRoute, Outlet } from '@tanstack/react-router'
import WorkspaceLayout from '@/layouts/WorkspaceLayout'

export const Route = createFileRoute('/$workspaceName')({
  component: WorkspaceLayoutRoute,
})

function WorkspaceLayoutRoute() {
  return (
    <WorkspaceLayout>
      <Outlet />
    </WorkspaceLayout>
  )
}
